import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UiModule } from '../../ui';
import { SharedUiModule } from '../../../shared/ui';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { DLCompanyService } from './company.service';
import { DLCompanyResolver } from './company.resolver';
import { DLCompanyListComponent } from './company-list.component';
import { DLCompanyEditComponent } from './company-edit.component';
import { DLCompanyFilterDialogComponent } from './company-filter-dialog.component';
import { DLLedgerEditComponent } from './ledger-edit.component';
import { DLLedgerResolver } from './ledger.resolver';
import { DLLedgerService } from './ledger.service';
import { DLDocumentService } from './document.service';
import { DLDocumentEditComponent } from './document-edit.component';
import { FileUploadModule } from 'ng2-file-upload';
import { DLDocumentDatePipe } from './document-date.pipe';
import { DLDocumentFormComponent } from './document-form.component';
import { DLAuthorizationListComponent } from './authorization-list.component';
import { DLCompanySearchDialogComponent } from './company-search-dialog.component';
import { DLAuthorizationService } from './authorization.service';

@NgModule({
  imports: [
    BrowserModule,
    SharedUiModule,
    UiModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    RouterModule,
    FileUploadModule,
  ],
  declarations: [
    DLCompanyListComponent,
    DLCompanyEditComponent,
    DLCompanyFilterDialogComponent,
    DLCompanySearchDialogComponent,
    DLLedgerEditComponent,
    DLDocumentEditComponent,
    DLDocumentFormComponent,
    DLDocumentDatePipe,
    DLAuthorizationListComponent,
  ],
  exports: [
    DLAuthorizationListComponent,
  ],
  providers: [
    DLCompanyService,
    DLCompanyResolver,
    DLLedgerService,
    DLLedgerResolver,
    DLDocumentService,
    DLAuthorizationService,
  ],
  bootstrap: [
    DLCompanyFilterDialogComponent,
    DLCompanySearchDialogComponent,
  ]
})
export class DLCompanyModule { }
